import generateUtilityClasses from '../../utils/generateUtilityClasses/generateUtilityClasses.js';
import generateUtilityClass from '../../utils/generateUtilityClass/generateUtilityClass.js';

function getTabsUtilityClass(slot) {
  return generateUtilityClass('MuiTabs', slot);
}
const tabsClasses = generateUtilityClasses('MuiTabs', ['root', 'vertical', 'flexContainer', 'flexContainerVertical', 'centered', 'scroller', 'fixed', 'scrollableX', 'scrollableY', 'hideScrollbar', 'scrollButtons', 'scrollButtonsHideMobile', 'indicator']);
var tabsClasses$1 = tabsClasses;

export { tabsClasses$1 as default, getTabsUtilityClass };
//# sourceMappingURL=tabsClasses.js.map
